import { Component, h } from '@stencil/core';

@Component({
  tag: 'utrecht-icon-energie-vergoeding',
  styleUrl: "../../icon/generated.scss",
  shadow: true,
})
export class UtrechtIconEnergieVergoeding {

  render() {
    return (
      <svg viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg" fill="currentColor" height="1em" width="1em">
  <path d="m35.92 6.77-4.45 6.77c-.19.28-.5.45-.85.45h-.05c-.71 0-1.2-.71-.94-1.36l1.43-3.64h-2.14c-.34 0-.58-.32-.48-.64l1.66-5.64c.13-.43.52-.72.97-.72h2.96c.39 0 .63.42.44.75l-1.91 3.25h2.95c.4 0 .64.44.42.77ZM17.93 18c2.23 0 4.03-1.79 4.03-4s-1.81-4-4.03-4-4.03 1.79-4.03 4 1.81 4 4.03 4m3.26 3.56c2.67.78 4 2.52 4.55 3.94 1.98-.25 3.52-1.91 3.52-3.95 0-2.21-1.81-4-4.03-4s-4.03 1.79-4.03 4Zm-16.15.52H1.01c-.56 0-1.01.45-1.01 1v7.95c0 .55.45 1 1.01 1h4.03c.56 0 1.01-.45 1.01-1v-7.95c0-.55-.45-1-1.01-1m25.63 6.3-10.47.66-2.89-.91a.913.913 0 0 1-.6-1.16c.16-.48.67-.75 1.16-.6l2.82.88 3.57-.3c-.01-.1-.32-2.6-3.51-3.49l-5.89-1.76c-.29-.09-.59-.11-.89-.06l-5.05.76c-.49.07-.86.49-.86.99v7.58l11.91 2.99c.15.04.3.04.46 0l13.62-2.83c.79-.16 1.1-1.16.5-1.69-.62-.56-1.77-1.08-3.87-1.08Z"/>
</svg>

    );
  }
}
